import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import classNames from 'classnames';

import isEmpty from 'lodash/isEmpty';
import { keyEmptyCheck } from 'aurora-utils/utils';
import { ADGMAlert, ADGMImage } from 'aurora-components';
import styles from './styles';

function DocumentsMain(props) {
  const {
    classes,
    applicationId,
    attributes,
    applicationType,
    documents,
    handleUploadDoc,
    handleDeleteDoc,
    handleDocDownload,
    isEditable = false,
    title,
  } = props;
  if (!isEditable && isEmpty(documents)) return null;
  const handleUpload = e => {
    const { name, files, dataset } = e.target;
    if (files[0]) {
      const fileIndex =
        documents?.filter(doc => doc.subType?.includes(`APPLICATION_${applicationId}.${name}_`))?.length + 1 || 1;
      const params = {
        applicationId,
        applicationType,
        documentType: name,
        subType: `APPLICATION_${applicationId}.${name}_${fileIndex}`,
      };
      if (dataset?.userId) {
        params.userId = dataset?.userId;
      }
      const formData = new FormData();
      formData.append('file', files[0]);
      handleUploadDoc && handleUploadDoc(formData, params);
    }
  };
  const handleViewFile = (name, subType, fileName) => {
    const payload = {
      applicationId,
      applicationType,
      documentType: name,
      subType,
      fileName: encodeURIComponent(fileName),
    };
    handleDocDownload && handleDocDownload(payload);
  };
  const handleFileRemove = file => {
    handleDeleteDoc && handleDeleteDoc(file);
  };

  const newAttributes = useMemo(() => {
    const newAttr = [...attributes];

    return newAttr;
  }, [attributes]);

  return (
    <Accordion
      key={applicationId}
      style={{ order: 3 }}
      className={classes.docAccordianFrame}
      classes={{
        expanded: classes.expandedDocAccordianFrame,
      }}
      defaultExpanded
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls='application-document'
        id={applicationId}
        className={classes.docAccordionTitleHead}
      >
        <Typography className={classes.docAccordionHeading}>
          {title ? keyEmptyCheck(title) : keyEmptyCheck('application_documents_lowerCase')}
        </Typography>
      </AccordionSummary>
      {(newAttributes || [])
        // Sort due to last-child CSS problem
        .sort((a, b) => a.order - b.order)
        ?.map((attr, index) => {
          if (attr.attributeType.toLowerCase() === 'file') {
            if (!isEditable) {
              return documents?.filter(doc => doc?.type === attr?.name)?.length > 0 ? (
                <AccordionDetails
                  className={classNames(
                    classes.docAccordianDetails,
                    index <
                      documents?.filter(doc => newAttributes.map(({ name }) => name).includes(doc?.type))?.length - 1
                      ? classes.borderBottom
                      : null,
                  )}
                >
                  <Accordion
                    className={classes.docChildAccordion}
                    classes={{
                      expanded: classes.docChildExpandeddAccordion,
                    }}
                    defaultExpanded
                  >
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.docChildAccordionTitleHead}>
                      <ADGMImage name='DocumentBlack.svg' alt='document' />
                      <Typography component='p'>{keyEmptyCheck(attr.title)}</Typography>
                    </AccordionSummary>
                    <AccordionDetails className={classes.docChildAccordianDetails}>
                      <div className={classes.docsFlexContainer}>
                        {documents
                          ?.filter(
                            doc =>
                              doc?.type === attr?.name &&
                              (doc.userId ? +doc.userId === +attr.userId : doc.userId === null) &&
                              doc?.companyId === null,
                          )
                          ?.map(file => (
                            <div key={file.id} className={classNames(classes.fileFlex)}>
                              <ADGMImage name='PDF.svg' alt='pdf' />
                              <Typography component='p'>{file.fileName}</Typography>
                              <Button onClick={() => handleViewFile(attr.name, file.subType, file?.fileName)}>
                                {keyEmptyCheck('view')}
                              </Button>
                            </div>
                          ))}
                      </div>
                    </AccordionDetails>
                  </Accordion>
                </AccordionDetails>
              ) : null;
            }
            return (
              <AccordionDetails
                className={classNames(
                  classes.docAccordianDetails,
                  index < newAttributes?.length - 1 ? classes.borderBottom : null,
                )}
              >
                <Accordion
                  // style={{ order: attr.order }}
                  className={classes.docChildAccordion}
                  classes={{
                    expanded: classes.docChildExpandeddAccordion,
                  }}
                  defaultExpanded
                >
                  <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.docChildAccordionTitleHead}>
                    <ADGMImage name='DocumentBlack.svg' alt='document' />
                    <Typography component='p'>
                      {keyEmptyCheck(attr.title)}
                      {attr?.mandatory && <span className={classes.mandatory}>*</span>}
                    </Typography>
                  </AccordionSummary>
                  {attr.message && (
                    <div className={classes.info}>
                      <ADGMAlert type='info' noBackground className='blackColor'>
                        {keyEmptyCheck(attr.message)}
                      </ADGMAlert>
                    </div>
                  )}
                  <AccordionDetails className={classes.docChildAccordianDetails}>
                    <div className={classes.docsFlexContainer}>
                      {documents
                        ?.filter(
                          doc =>
                            doc.type === attr.name &&
                            (doc.userId ? +doc.userId === +attr.userId : doc.userId === null) &&
                            doc.companyId === null,
                        )
                        ?.map(file => (
                          <div key={file.id} className={classNames(classes.fileFlex)}>
                            <ADGMImage name='PDF.svg' alt='pdf' />
                            <Typography component='p'>{file.fileName}</Typography>
                            <Button onClick={() => handleFileRemove(file)}>{keyEmptyCheck('remove')}</Button>
                          </div>
                        ))}
                      {(documents?.filter(
                        doc =>
                          doc.type === attr.name &&
                          (doc.userId ? +doc.userId === +attr.userId : doc.userId === null) &&
                          doc.companyId === null,
                      )?.length || 1) < 3 && (
                        <label htmlFor={attr.id}>
                          <input
                            id={attr.id}
                            name={attr.name}
                            type='file'
                            accept='application/pdf'
                            multiple
                            hidden
                            data-user-id={attr?.userId}
                            onChange={handleUpload}
                            onClick={e => {
                              e.target.value = null;
                            }}
                          />
                          <Button
                            variant='outlined'
                            component='span'
                            id={attr.id}
                            name={attr.name}
                            className={classes.largeButton}
                          >
                            <ADGMImage name='uplaodIcon.svg' alt='icon' />
                            <Typography component='p'>{keyEmptyCheck('upload_document')}</Typography>
                          </Button>
                        </label>
                      )}
                    </div>
                  </AccordionDetails>
                </Accordion>
              </AccordionDetails>
            );
          }
          return null;
        })}
    </Accordion>
  );
}

DocumentsMain.propTypes = {
  classes: PropTypes.object.isRequired,
  applicationId: PropTypes.number.isRequired,
  applicationType: PropTypes.string.isRequired,
  documents: PropTypes.array.isRequired,
  handleUploadDoc: PropTypes.func.isRequired,
  isEditable: PropTypes.bool.isRequired,
  handleDeleteDoc: PropTypes.func.isRequired,
  attributes: PropTypes.array.isRequired,
  handleDocDownload: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
};

export default withStyles(styles)(DocumentsMain);
